<div id="news" class="news bg-light">
    <div class="container">
        <div class="row mt-3">
            <div class="col-12">
                <h1 class="fw-bold title ps-3 display-5">News</h1>
            </div>
        </div>
        <div class="row mt-5">
            <div class="col-12 mb-4" *ngFor="let item of newsList; let i=index">
                <h4 class="text-secondary news-date pb-2 mb-3">{{item.date}}</h4>
                <div class="card border-0 mb-3 shadow-sm lead" *ngFor="let news of item.list">
                    <div class="card-body">
                        {{news}}
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>